export const ARROW_LENGTH = 32;

export const ARROW_OFFSET = 8;

export const SMART_SELECT_BUTTON_HEIGHT = 26;

export const SMART_SELECT_BUTTON_WIDTH = 188;

export const SMART_SELECT_PANEL_WIDTH = 613;

export const SMART_SELECT_PANEL_HEIGHT = 609;

export const SMART_SELECT_OPTION_CARD_WIDTH = 132;

export const SMART_SELECT_OPTION_CARD_HEIGHT = 286;

export const SMART_SELECT_SUGGESTION_FETCH_COUNT = 9;

export const SMART_SELECT_OPTIONS_PER_PAGE = 3;

export const SMART_SELECT_PAGINATION_PANEL_NAME =
  'SMART_SELECT_PAGINATION_PANEL';

export const SMART_SELECT_PREVIOUS_PAGE_NAME = 'SMART_SELECT_PREVIOUS_PAGE';

export const SMART_SELECT_NEXT_PAGE_NAME = 'SMART_SELECT_NEXT_PAGE';

export const SMART_SELECT_PLACE_BUTTON_FILL = '#A08C64';

export const SMART_SELECT_PREVIEW_BACKGROUND_FILL = 'rgba(0, 0, 0, 0.08)';

export const SMART_SELECT_PLACEMENT_PREVIEW_SIZE = 96;

export const SMART_SELECT_PANEL_GAP = 16;

export const SMART_SELECT_VIEWPORT_PADDING = 16;

export const SMART_SELECT_LEFT_TOOLBAR_CLEARANCE = 84;

export const SMART_SELECT_PLACEMENT_PREVIEW_IMAGE_NAME =
  'SMART_SELECT_PLACEMENT_PREVIEW_IMAGE';

export const SMART_SELECT_USE_BUTTON_SHAPE_NAME =
  'SMART_SELECT_USE_BUTTON_SHAPE';

export const SMART_SELECT_USE_BUTTON_TEXT_NAME = 'SMART_SELECT_USE_BUTTON_TEXT';

export const SMART_SELECT_OUTPUT_PILLS_PANEL_NAME =
  'SMART_SELECT_OUTPUT_PILLS_PANEL';

export const SMART_SELECT_PARTICLE_SIZE_TEXT_NAME =
  'SMART_SELECT_PARTICLE_SIZE_TEXT';

export const SMART_SELECT_CAPACITY_TEXT_NAME = 'SMART_SELECT_CAPACITY_TEXT';

export const SMART_SELECT_RECOMMENDED_OPTIONS_PANEL_NAME =
  'SMART_SELECT_RECOMMENDED_OPTIONS_PANEL';

export const HOVER_HIDE_DELAY_MS = 600;

export const HOVER_HIT_PADDING = 16;

const SMART_SELECT_ICON_SVG =
  '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5898 2.02276C8.70762 1.93339 8.85143 1.88501 8.99931 1.88501C9.14719 1.88501 9.291 1.93339 9.40882 2.02276C9.52664 2.11213 9.61198 2.23759 9.65183 2.37999L9.65365 2.38675L10.7249 6.54371C10.7249 6.54374 10.7249 6.54369 10.7249 6.54371C10.7703 6.71955 10.862 6.88011 10.9904 7.00852C11.1188 7.13695 11.2793 7.22862 11.4552 7.27399L15.6122 8.34525L15.6177 8.34673C15.7607 8.38616 15.8867 8.47142 15.9766 8.58941C16.0665 8.7074 16.1151 8.85162 16.1151 8.99993C16.1151 9.14824 16.0665 9.29245 15.9766 9.41045C15.8867 9.52844 15.7607 9.61369 15.6177 9.65313L15.6122 9.65461L11.4552 10.7259C11.2793 10.7712 11.1188 10.8629 10.9904 10.9913C10.862 11.1198 10.7703 11.2803 10.7249 11.4561L9.65296 15.6132L9.65116 15.6199C9.6113 15.7623 9.52596 15.8877 9.40814 15.9771C9.29033 16.0665 9.14651 16.1148 8.99863 16.1148C8.85075 16.1148 8.70694 16.0665 8.58912 15.9771C8.47131 15.8877 8.38596 15.7623 8.34611 15.6199L8.34429 15.6131L7.27304 11.4561C7.22766 11.2803 7.13599 11.1198 7.00756 10.9913C6.87914 10.8629 6.71865 10.7712 6.54279 10.7259L2.38574 9.65392L2.37783 9.65178C2.23599 9.61151 2.11114 9.52608 2.02225 9.40844C1.93335 9.2908 1.88525 9.14738 1.88525 8.99993C1.88525 8.85248 1.93335 8.70905 2.02225 8.59141C2.11114 8.47377 2.23599 8.38834 2.37783 8.34808L2.38569 8.34595L6.54274 7.27332C6.71855 7.22799 6.87907 7.13638 7.0075 7.00804C7.13593 6.87971 7.22763 6.71931 7.27308 6.54353L8.34498 2.3867L8.34679 2.37999C8.38664 2.23759 8.47198 2.11213 8.5898 2.02276ZM8.99931 2.56289L7.92916 6.71294C7.85341 7.00591 7.70051 7.27345 7.48647 7.48734C7.27244 7.70122 7.00503 7.85387 6.71203 7.92943L2.56324 8.99993L6.71198 10.0697C7.00511 10.1454 7.27264 10.2982 7.48669 10.5122C7.70075 10.7263 7.85353 10.9938 7.92915 11.2869L8.99863 15.437L10.0688 11.2869C10.1444 10.9938 10.2972 10.7263 10.5112 10.5122C10.7253 10.2982 10.9928 10.1454 11.2859 10.0698L15.4373 8.99993L11.286 7.93013C10.9929 7.85451 10.7253 7.7017 10.5112 7.48765C10.2972 7.2736 10.1444 7.0061 10.0688 6.71298L8.99931 2.56289ZM14.4197 2.56277C14.6068 2.56277 14.7585 2.71446 14.7585 2.90157V3.91796H15.7749C15.962 3.91796 16.1137 4.06965 16.1137 4.25676C16.1137 4.44387 15.962 4.59556 15.7749 4.59556H14.7585V5.61195C14.7585 5.79907 14.6068 5.95075 14.4197 5.95075C14.2326 5.95075 14.0809 5.79907 14.0809 5.61195V4.59556H13.0645C12.8774 4.59556 12.7257 4.44387 12.7257 4.25676C12.7257 4.06965 12.8774 3.91796 13.0645 3.91796H14.0809V2.90157C14.0809 2.71446 14.2326 2.56277 14.4197 2.56277ZM3.57821 12.0491C3.76532 12.0491 3.91701 12.2008 3.91701 12.3879V12.7267H4.2558C4.44292 12.7267 4.5946 12.8784 4.5946 13.0655C4.5946 13.2526 4.44292 13.4043 4.2558 13.4043H3.91701V13.7431C3.91701 13.9302 3.76532 14.0819 3.57821 14.0819C3.3911 14.0819 3.23941 13.9302 3.23941 13.7431V13.4043H2.90061C2.7135 13.4043 2.56182 13.2526 2.56182 13.0655C2.56182 12.8784 2.7135 12.7267 2.90061 12.7267H3.23941V12.3879C3.23941 12.2008 3.3911 12.0491 3.57821 12.0491Z" fill="#327DFF"/></svg>';

export const SMART_SELECT_ICON_SOURCE = `data:image/svg+xml,${encodeURIComponent(
  SMART_SELECT_ICON_SVG,
)}`;

const SMART_SELECT_CLOSE_ICON_SVG =
  '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.25 4.25L11.75 11.75M11.75 4.25L4.25 11.75" stroke="#101010" stroke-width="1.5" stroke-linecap="round"/></svg>';

export const SMART_SELECT_CLOSE_ICON_SOURCE = `data:image/svg+xml,${encodeURIComponent(
  SMART_SELECT_CLOSE_ICON_SVG,
)}`;
